module.exports = __webpack_public_path__ + "img/qr-group.de240156.png";